import map from "../../images/map2.png";
import { useSelector, useDispatch } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { setAppearance } from "../../redux/slices/appearanceslice";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  const appearance = useSelector((state) => state.appearance);
  return (
    <>
      <footer className="footer-area bg-fffcf4">
        <div className="copyright-area">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7 col-md-7">
                <p>
                  <i className="far fa-copyright"></i> {currentYear}
                  {t("static.footer.rights")}{" "}
                  <a href="https://intech-mena.com/">{t("static.footer.website")}</a> |{" "}
                  <a href="/termsandconditions">{t("static.footer.terms")}</a><br/>
                  <a href="/privacy-policy">{t("static.footer.privacy")}</a>{" "}|{" "}
                  <a href="/support">{t("static.footer.support")}</a>
                </p>
              </div>

              <div className="col-lg-5 col-md-5 footer-icons">
                <ul>
                  {/* <li>
                    <a href="https://www.facebook.com/" target="_blank">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com/" target="_blank">
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li> */}
                  <li>
                    <a
                      href="https://www.instagram.com/intechfzco?igsh=MXNxdGl6dW01eDcwNA=="
                      target="_blank"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/intech-sal/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="map2">
          <img src={map} alt="map" width={642} height={312} />
        </div>
      </footer>
      <style>
        {
          `
          .footer-icons {
            justify-content: end;
            display: flex;
          }
          `
        }
      </style>
    </>
  );
};

export default Footer;
